import { call, put, takeLeading } from 'redux-saga/effects';
import {
    FETCH_USER_INFO,
} from '../../actions/actionTypes';
import { setUserInfoAction } from '../../actions/actionCreators';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../api/headers';
import { DEFAULT_BASE_URL, GET_USER_INFO } from '../../api/urls';
import { apiRequest } from '../../api';

export function* getUserInfo() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: GET_USER_INFO,
    };
    try {
        const { data } = yield call(apiRequest, requestConfig);
        yield put(setUserInfoAction(data));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchFetchUserInfo() {
    yield takeLeading(FETCH_USER_INFO, getUserInfo);
}
